<template>
  <kst-action>
    <kst-action-item>
      <kst-button action-mode
        :module="Model.Item.Module"
        :moduleType="Model.Item.ModuleType.Edit"
        :urlParams="urlParams"
      />
    </kst-action-item>
  </kst-action>
</template>

<script>
import Model from "../StockModel.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: this.data.ItemID
      });
    }
  }
}
</script>